(() => {
  'use strict';

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const addHiddenField = (parent, name, value) => {
    if (!value) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    parent.append(input);
  };

  const findAvailableDyeLabRequestSection = () => {
    const main = document.getElementById('MainContent');
    if (!main) return null;

    const productInformation = main.querySelector('[data-testid="product-information"]');
    const availableControl =
      document.querySelector('sticky-add-to-cart[data-variant-available="true"]') ||
      productInformation?.querySelector('.add-to-cart-button:not([disabled])');
    if (!availableControl) return null;

    for (const section of main.querySelectorAll('.shopify-section')) {
      const heading = Array.from(section.querySelectorAll('h1, h2, h3, h4, h5, h6')).find((element) => {
        const text = normalize(element.textContent);
        return text === 'like what you see?' || text === 'want your own version?';
      });
      if (!heading) continue;

      const requestLink = Array.from(section.querySelectorAll('a[href]')).find((link) => {
        const label = normalize(link.textContent);
        const href = link.getAttribute('href') || '';
        return label === 'request a custom dye' && href.includes('/pages/contact');
      });

      if (requestLink) return { section, heading, requestLink };
    }

    return null;
  };

  const enhanceAvailableDyeLabProduct = () => {
    const match = findAvailableDyeLabRequestSection();
    if (!match) return;

    const main = document.getElementById('MainContent');
    const productTitle = Array.from(main.querySelectorAll('h1')).map((heading) => heading.textContent.trim()).find(Boolean);
    if (!productTitle) return;

    const canonicalUrl = document.querySelector('link[rel="canonical"]')?.href || window.location.href.split('?')[0];
    const requestUrl = new URL('/pages/contact', window.location.origin);
    requestUrl.searchParams.set('source', 'dye-lab-product');
    requestUrl.searchParams.set('inspiration', productTitle);
    requestUrl.searchParams.set('inspiration_url', canonicalUrl);

    match.heading.textContent = 'Want your own version?';
    match.requestLink.textContent = 'Request a Custom Dye';
    match.requestLink.href = requestUrl.pathname + requestUrl.search;
    match.section.dataset.pinehurstDyeProductHandoff = '';
  };

  const enhanceContactForm = () => {
    if (window.location.pathname !== '/pages/contact') return;

    const params = new URLSearchParams(window.location.search);
    const source = params.get('source');
    const isMoldRequest = source === 'mold-collection';
    if (source !== 'dye-lab-product' && !isMoldRequest) return;

    const form = document.querySelector('.contact-form__form');
    const message = form?.querySelector('textarea[name="contact[body]"]');
    if (!form || !message || form.querySelector('[data-pinehurst-dye-product-request]')) return;

    const inspiration = (params.get('inspiration') || '').trim();
    const inspirationUrl = (params.get('inspiration_url') || '').trim();
    const mold = (params.get('mold') || '').trim().slice(0, 80);
    const manufacturer = (params.get('manufacturer') || '').trim().slice(0, 100);
    const plastic = (params.get('plastic') || '').trim().slice(0, 100);
    let labels = {};
    try {
      labels = JSON.parse(document.getElementById('PinehurstMoldRequestLabels')?.textContent || '{}');
    } catch {
      return;
    }
    if (isMoldRequest && (!mold || !manufacturer || !labels.message)) return;
    const moldTitle = isMoldRequest
      ? labels.title.replace('__MOLD__', mold).replace('__MANUFACTURER__', manufacturer)
      : '';

    const context = document.createElement('div');
    context.className = 'pinehurst-dye-product-request';
    context.dataset.pinehurstDyeProductRequest = '';

    const label = document.createElement('span');
    label.className = 'pinehurst-dye-product-request__label';
    label.textContent = isMoldRequest ? labels.startingFrom : 'Starting from';

    const title = document.createElement('strong');
    title.textContent = isMoldRequest ? moldTitle : inspiration || 'Pinehurst Dye Lab piece';

    const intro = document.createElement('p');
    intro.textContent = isMoldRequest ? labels.intro : 'Use this piece as a reference, or tell me what you want changed.';

    context.append(label, title, intro);
    addHiddenField(context, 'contact[Request source]', isMoldRequest ? 'Mold page' : 'Dye Lab product');
    addHiddenField(context, 'contact[Requested manufacturer]', isMoldRequest ? manufacturer : '');
    addHiddenField(context, 'contact[Requested mold]', isMoldRequest ? mold : '');
    addHiddenField(context, 'contact[Preferred plastic]', plastic);
    addHiddenField(context, 'contact[Inspiration piece]', inspiration);
    addHiddenField(context, 'contact[Inspiration URL]', inspirationUrl);

    const messageLabel = form.querySelector('label[for="ContactForm-body"]');
    form.insertBefore(context, messageLabel || message);

    if (!message.value.trim()) {
      message.value = isMoldRequest ? labels.message.replace('__MOLD__', moldTitle).replace('__PLASTIC__', plastic) : inspiration
        ? "I'm interested in a custom dye inspired by: " + inspiration + '.\n\n'
        : "I'm interested in a custom dye inspired by a Pinehurst Dye Lab piece.\n\n";
      message.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };

  const initialize = () => {
    enhanceAvailableDyeLabProduct();
    enhanceContactForm();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
